import { Stack } from "react-bootstrap";
import { AntInput } from "../AntInput";
import { Badge, Flex } from "antd";
import BtnAsLink from "@/Component/BtnAsLink";
import { HugeiconsIcon } from "@hugeicons/react";
import { FilterIcon, Search01Icon } from "@hugeicons/core-free-icons/index";
import { useTranslation } from "react-i18next";
import { useFilter } from "../TableC/hooks/useFilter";
import { filterObject } from "@/utils/helpers";
import { useDebouncedSearch } from "@/utils/hooks/useDebouncedSearch";
import { useEffect } from "react";
import { GenericFilterModal } from "../TableC";

export const SearchFilter = ({
  debounced = true,
  onChange,
  filterFields = [],
}) => {
  const { filters, isFilterOpen, setIsFilterOpen, handleFilterApply } =
    useFilter();
  const { t } = useTranslation();
  const { searchValue, debouncedValue, setSearchValue } = useDebouncedSearch(
    "",
    500
  );

  useEffect(() => {

    if (debounced) handleChange({ search: debouncedValue });
  }, [debouncedValue]);

  const handleChange = (value = {}) => {
    const count =
      Object.values(filterObject({ ...filters, ...value }))?.length || 0;

    onChange?.({ ...filters, search: searchValue, ...value, count });
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (!debounced) handleChange({ search: value });
  };

  const filterCount = Object.values(filters)?.length;

  const onApply = (filteredData) => {
    const filterState = filterObject(filteredData) || {};
    handleFilterApply(handleChange)({ ...filterState });
  };

  return (
    <Stack direction="horizontal" gap={2}>
      <div className="flex-fill">
        <AntInput
          prefix={<HugeiconsIcon icon={Search01Icon} />}
          type="text"
          placeholder={t("SEARCH_HERE")}
          value={searchValue}
          onChange={handleSearchChange}
        />
      </div>


      {!!filterFields?.length && <>
        <Flex gap={8}>
          <Badge count={filterCount || 0}>
            <BtnAsLink
              className="btn-secondary"
              icon={<HugeiconsIcon icon={FilterIcon} />}
              onClick={() => setIsFilterOpen(true)}
            >
              {t("FILTER")}
            </BtnAsLink>
          </Badge>
        </Flex>

        <GenericFilterModal
          isOpen={isFilterOpen}
          toggle={() => setIsFilterOpen(false)}
          onReset={(values) => onApply?.(values)}
          {...{
            onApply,
            filters,
            filterFields,
          }}
        />
      </>}
    </Stack>
  );
};
